import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  scopeCategoriesSummary(scope: number) {
    return axios.get<SummarizedPreconfiguredEfByCategory>(`/v2/ghg/preconfigured-efs/summary/?scope=${scope}`)
  },
  getCategoryById(categoryId: string) {
    return axios.get<FilterOptionItem[]>(`/v2/ghg/categories/${categoryId}/`)
  },
  getPreconfiguredEmissionFactors(params?: GhgPreconfiguredEmissionFactorsParams) {
    return axios.get<PaginatedResponse<PreconfiguredEmissionFactor>>('/v2/ghg/preconfigured-efs/', { params })
  },
  filterPreconfiguredEmissionFactorsField(params: EmissionFactorFilterParams) {
    return axios.get<PaginatedResponse<FilterOptionItem | GhgReportingyearFilteredItem | { value: string }>>
    (
      '/v2/ghg/preconfigured-efs/filters/',
      { params },
    )
  },
  deletePreconfiguredEmissionFactor(id: string) {
    return axios.delete(`/v2/ghg/preconfigured-efs/${id}/`)
  },
  reportingYears(params?: PaginationParams) {
    return axios.get<PaginatedResponse<GhgEfReportingYear>>('/v2/ghg/preconfigured-efs/reporting-years/', { params })
  },
  efSuggestions(params?: EmissionFactorSuggestionParams) {
    return axios.get<PaginatedResponse<SuggestedEmissionFactor>>('/v2/ghg/emission-factors/search-results/', { params })
  },
  savePreconfiguredEf(payload: CreateGhgPreconfiguredEfPayload) {
    return axios.post('/v2/ghg/preconfigured-efs/', payload)
  },
  editPreconfiguredEf(id: string, payload: CreateGhgPreconfiguredEfPayload) {
    return axios.patch(`/v2/ghg/preconfigured-efs/${id}/`, payload)
  },
  listEfMatchingFilters(category: number, is_draft: boolean = true) {
    return axios.get<EmissionFactorMatchingFilters>
    ('/v2/ghg/ghg-preview-page/filters/', {
      params: { category, is_draft },
    })
  },
})
